import './home.scss'
import { ListMusic } from '@/components/organisms/ListMusic'
import { useAppSelector } from '@/app/hooks'
import { selectPlaylist } from '@/features/playlist/playlistSlice'

export const Home = () => {
    const { playlists, status: { playlistsState } } = useAppSelector(selectPlaylist)
    return (
        <main className='p-home'>
            <ListMusic playlists={playlists} status={playlistsState} />
        </main>
    )
}
